<template>
  <div
    v-if="progressState.show"
    class="top-progress-bar-container"
    :style="{ opacity: progressState.opacity }"
    aria-hidden="true"
  >
    <div
      class="top-progress-bar"
      :class="{
        'top-progress-bar--error': progressState.status === 'error',
      }"
      :style="{ width: progressState.percent + '%' }"
    >
      <div class="top-progress-bar-glow"></div>
    </div>
  </div>
</template>

<script setup>
import { progressState } from "@/helpers/top-progress";
</script>

<style scoped>
.top-progress-bar-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  z-index: 9999999 !important;
  pointer-events: none;
  transition: opacity 0.25s ease-out;
}

.top-progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #405189 0%, #0ab39c 50%, #299cdb 100%);
  box-shadow: 0 0 8px rgba(10, 179, 156, 0.6);
  transition: width 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;
  border-radius: 0 2px 2px 0;
}

.top-progress-bar--error {
  background: linear-gradient(90deg, #f06548 0%, #f7b84b 100%) !important;
  box-shadow: 0 0 10px rgba(240, 101, 72, 0.8) !important;
}

.top-progress-bar-glow {
  position: absolute;
  top: 0;
  right: 0;
  width: 70px;
  height: 100%;
  box-shadow: 0 0 10px #0ab39c, 0 0 5px #299cdb;
  opacity: 1;
  transform: rotate(3deg) translate(0px, -2px);
}
</style>
